import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Links } from 'SRC/modules/common/components/Pagination'
import { getProfilePaginationParams } from '../../selectors'

export class SavedFilters extends React.PureComponent {
  getPageCount = () => {
    const { paginationParams } = this.props

    return Math.ceil(paginationParams.count / paginationParams.countPerPage)
  }

  getBaseUrl = () => {
    return {
      href: {
        pathname: `/profile`,
        query: {
          page: 'sacuvane-pretrage'
        }
      },
      as: `/profil/sacuvane-pretrage`
    }
  }

  getPrevUrl = () => ({
    href: {
      pathname: this.getBaseUrl().href.pathname,
      query: {
        ...this.getBaseUrl().href.query,
        pageNumber: Number(this.props.paginationParams.currentPage) - 1
      }
    },
    as: {
      pathname: this.getBaseUrl().as,
      query: {pageNumber: Number(this.props.paginationParams.currentPage) - 1}
    }
  })

  getNextUrl = () => ({
    href: {
      pathname: this.getBaseUrl().href.pathname,
      query: {
        ...this.getBaseUrl().href.query,
        pageNumber: Number(this.props.paginationParams.currentPage) + 1
      }
    },
    as: {
      pathname: this.getBaseUrl().as,
      query: {pageNumber: Number(this.props.paginationParams.currentPage) + 1}
    }
  })

  getPages = (pageCount = 1) => {
    const pages = []
    const baseUrl = this.getBaseUrl()
    const current = Number(this.props.paginationParams.currentPage)
    for (let i = 1; i <= pageCount; i++) {
      pages.push({
        number: i,
        isCurrent: i === current,
        href: {
          pathname: baseUrl.href.pathname,
          query: { ...baseUrl.href.query, pageNumber: i }
        },
        as: {pathname: baseUrl.as, query: {pageNumber: i}}
      })
    }
    return pages
  }

  render () {
    const pageCount = this.getPageCount()
    const pages = this.getPages(pageCount)
    const currentPage = Number(this.props.paginationParams.currentPage)
    const isFirstPage = currentPage === 1
    const isLastPage = currentPage === pageCount
    const prevUrl = this.getPrevUrl()
    const nextUrl = this.getNextUrl()

    if (pageCount <= 0) return null

    return (
      <Links
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        prevUrl={prevUrl}
        nextUrl={nextUrl}
        pages={pages}
      />
    )
  }
}

const mapStateToProps = state => ({
  paginationParams: getProfilePaginationParams(state)
})

SavedFilters.propTypes = {
  paginationParams: PropTypes.shape({
    currentPage: PropTypes.number,
    countPerPage: PropTypes.number,
    count: PropTypes.number
  }).isRequired
}

export default connect(mapStateToProps)(SavedFilters)
